var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgLockFilled = function SvgLockFilled(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Lock' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47C11.2974508 47 1 36.7025492 1 24S11.2974508 1 24 1s23 10.2974508 23 23-10.2974508 23-23 23z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0219427 18C16.2794256 12.2802358 18.8102572 9 24 9c5.1897428 0 7.7205744 3.2802358 7.9780573 9H35v18H13V18h3.0219427zm2.0007288 0h11.954657C29.7567576 13.3144463 27.9163065 11 24 11c-3.9163065 0-5.7567576 2.3144463-5.9773285 7zM24 30.2222222c.3837778 0 .7162222-.2603333.8011667-.627l.9857222-3.2883889c.2609444-1.1250555-.6111111-2.1957222-1.7868889-2.1957222-1.1757778 0-2.0478333 1.0706667-1.7868889 2.1957222l.9857222 3.2883889c.0849445.3666667.4173889.627.8011667.627z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};
SvgLockFilled = pure(SvgLockFilled);
SvgLockFilled.displayName = 'SvgLockFilled';
export default SvgLockFilled;